import 'lightgallery/dist/js/lightgallery';



// WEBPACK FOOTER //
// ./scripts/autoload/_lightgallery.js